
export const detailKeywordStyle = theme => ({

})